import {find, findKey} from "lodash";

export const DueDiligenceStatus = Object.freeze({
  PENDING: "pending",
  SCREENING_IN_PROGRESS: "screening_in_progress",
  FPM_IN_PROGRESS: "fpm_in_progress",
  FPM_DONE: "fpm_done",
});

export const InduedReportStatus = Object.freeze({
  IN_PROGRESS: "in_progress",
  SUCCEEDED: "succeeded",
});

export const InduedScores = Object.freeze([
  "country_score",
  "activity_score",
  "pep_score",
  "sanctions_score",
  "adverse_media_score",
]);

export const InduedAllScores = Object.freeze([
  "risk_level",
  ...InduedScores
]);

export const InduedSeverityEnum = Object.freeze({
  NOT_STARTED: "-1",
  UNKNOWN: "0",
  LOW: "1",
  MEDIUM: "2",
  HIGH: "3"
})

export const induedScoreSeverity = (score) => {
  switch (score) {
    case 1:
      return {
        label: "low",
      };
    case 2:
      return {
        label: "medium",
      };
    case 3:
      return {
        label: "high",
      };
    default:
      return {
        label: "unknown",
      };
  }
};

export const getInduedColor = (score) => {
  switch (score) {
    case 1:
      return "#54CC54";
    case 2:
      return "#FF9A00";
    case 3:
      return "#CC0001";
    default:
      return "#535362";
  }
}

export const isInduedDone = (induedData) => {
  return induedData?.due_diligence?.status === DueDiligenceStatus.FPM_DONE && 
    induedData?.report_data?.status === InduedReportStatus.SUCCEEDED;
}

export const formatInduedRiskLevel = (indued) => {
  if(!indued?.created_date) return "not_started";
  const riskLevel = indued?.due_diligence?.risk_level;
  return induedScoreSeverity(riskLevel).label;
}

export const thirdpartyInduedFilterPredicate = (indued, filter) => {
  // No Screening
  if(filter.type === "risk_level" && filter.id === InduedSeverityEnum.NOT_STARTED && (!indued || !indued.created_date )) {
    return true;
  }
  // tp has indued
  if(indued?.created_date) {
    // Tps with no due_diligence are considered unknown
    if(filter.id === InduedSeverityEnum.UNKNOWN && !indued.due_diligence) {
      return true;
    }
    // Score matches the filter
    if(indued.due_diligence?.[filter.type] === +filter.id) {
      return true;
    }
  }
  return false;
}

export const splitInduedFiltersByScore = (filters) => {
  let induedFilters = filters?.reduce((res, filter) => {
    const { type } = filter;
    const scoreObj = find(res, {score: type});
    const value = findKey(InduedSeverityEnum, (value) => value === filter.id);

    // Add a new score object if it doesnt exist.
    if (!scoreObj) {
      res.push({score: type, values: [value]})
    } else {
      // or add the value to its existing filter values.
      scoreObj.values.push(value)
    }
    return res;
  }, []);
    
  // Add remaining scores with empty values if they don't already exist
  const orderedFilters = [];
  InduedAllScores.forEach((score) => {
    const scoreFilter = induedFilters.find((filter) => filter.score === score);
    orderedFilters.push(scoreFilter || { score, values: [] });
  });

  return orderedFilters;
}